import { HeaderTabsState, IHeaderTabGroup } from '../HeaderTabs';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { initCap } from '../utils/format';
import { AGENCY_TAB_LABEL, AGENCY_TABS, agencyTabPath, IAgencyTab } from './agencyTabs';

const TAB_GROUP_ID = 'agency-tabs';

export class AgencyTabsProvider {

    static inject = () => [HeaderTabsState, MixPanelEventEmitter];
    constructor(private tabsState: HeaderTabsState, private tracking: MixPanelEventEmitter) {}

    getTabs = (): IHeaderTabGroup => ({
        tabGroupId: TAB_GROUP_ID,
        tabs: AGENCY_TABS.map(tab => ({
            label: AGENCY_TAB_LABEL[tab],
            url: agencyTabPath(tab),
            dataId: `agency-tab-${tab}`
        }))
    });

    /** The tab events count arrivals, so arriving by name counts as much as clicking the tab. */
    trackOpened = (tab: IAgencyTab) => {
        this.tracking.track(`${initCap(tab)} Tab Opened`);
    };

    /** Where the agency home opens when nothing names a tab: wherever the reader last was, else Insights. */
    getLandingTab = (): IAgencyTab => {
        const lastUrl = this.tabsState.getLastActiveTab(TAB_GROUP_ID)?.url;
        return AGENCY_TABS.find(tab => agencyTabPath(tab) === lastUrl) || 'insights';
    };
}
